import React from 'react'
import { Disclaimer } from 'components/styledComponents/disclaimer'
import NonInsuranceDisclaimer from './nonInsuranceDisclaimer'
import InsuranceDisclaimer from './insuranceDisclaimer'
import { useLocation } from 'react-router-dom'

export const NonGovdisclaimer = () => {
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const insuranceDisclaimer =
    result === 'review' || result === 'pdfview' || result.indexOf('-') > -1
  return (
    <Disclaimer>
      {insuranceDisclaimer ? (
        <InsuranceDisclaimer />
      ) : (
        <NonInsuranceDisclaimer />
      )}
      <p>
        <strong>Things you need to know:</strong>{' '}This general information doesn’t take your personal 
        circumstances into account. Please read the product disclosure statement (PDS) and target market 
        determination (TMD) and consider whether this information is right for you before making a decision 
        and seek professional independent tax and financial advice. Conditions and fees apply, along with 
        credit assessment criteria for lease products. The availability of novated leasing is subject to 
        your employer's approval. Oly may pay and/or receive commissions in connection with its services.
      </p>
      <p>
        Oly collected your personal information when you obtained an estimate for novated leasing and/or 
        applied for the novated leasing product. Oly may use this information to provide you with the estimate, 
        the novated leasing product and administer your relationship with Oly, to contact you about our other 
        products, services and offerings, and for other related purposes (including direct marketing and 
        online targeted advertising). To read more about how Oly will handle your personal information, 
        please read Oly’s privacy statement. Oly is part of the McMillan Shakespeare Limited Group (MMS Group). 
        You can find Oly’s Privacy Policy (which is the MMS Group’s Privacy Policy) by clicking <a
          href="https://www.oly.com.au/privacy-policy"
          text="here"
          classes="text-underline"
        >here</a>. 
        The Privacy Policy contains important information about how Oly (and the MMS Group) collect, hold, 
        use and disclose your personal information (including to recipients located outside of Australia), 
        the security of your personal information, how you may access and correct your personal information,
        and how you can make a privacy complaint and how Oly will deal with such complaint.  
      </p>      
    </Disclaimer>
  )
}
